import { getFEWalletParams } from '../../../platform.pay.config'
import { DefaultDate } from '../../../platform.es.config'
/**
 * 將數字格式化為帶有逗號的字串形式，可選在數值後面加上 `000`。
 *
 * @param {number} num 需要格式化的數字。
 * @param {boolean} [addThousand=false] 用於指示是否需要在後面加上 `000`。預設為 false。
 * @returns {string}
 */
export const numberWithCommas = (num, addThousand = false) => {
  const parsedNum = Number(num);

  if (isNaN(parsedNum)) {
    return "0";
  }

  const numberToProcess = addThousand ? parsedNum * 1000 : parsedNum;
  return numberToProcess.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const NamewithAsterisk = (name) => {
	let nameAsterisk = ''
	if (name && name != '') {
		let nameList = name.toString().trim().split(' ')
		nameList.forEach((item) => {
			nameAsterisk = `${nameAsterisk} ${item.slice(0, 1)}******`
		})
	}
	return nameAsterisk
}
//sessionStorage缓存,web mobile刷新页面使用
let Storage = {}
export const SetStorage = (key, value) => {
	Storage[key] = value
	const { device } = GetParamsData()
	if(device != 'APP') {
		sessionStorage && sessionStorage.setItem(key, JSON.stringify(value))
	}
}
//缓存
export const GetStorage = (key) => {
	let data = Storage[key] || ''
	const { device } = GetParamsData()
	if(device != 'APP') {
		data = sessionStorage && sessionStorage.getItem(key)
		data = JSON.parse(data)
	}
	return data
}

export const bankCodeWriting = (item = '') => {
	if (item && item != '') {
		return item.replace(/\s/ig, '').replace(/[\.\(\),-]/g, '').toLocaleUpperCase()
	}
	return 'default'
}
//对外交互方法
export function GetParamsData() {
	return getFEWalletParams() || {}
}
//api提交默认参数
export const PostDepositDefaultDate = () => {
	const { device, platformType, languageType } = GetParamsData()
	const platformDate = DefaultDate[(platformType + languageType)][device] || {}

	return platformDate
}

export const MethodList = ['BQR', 'CC', 'FP', 'LB', 'LBQR', 'MMO', 'PHC', 'QD', 'VP', 'ZLP', 'CTC']
